import { useState, useCallback, useMemo } from 'react';
import { getDatesForRangeType } from '@components/Kendo/DateRangePickerReducer';
import { THIS_MONTH, LAST_MONTH, THIS_QUARTER, LAST_QUARTER, THIS_YEAR, LAST_YEAR, CUSTOM_RANGE } from '../../../../constants/Kendo/rangeOptions';
import { validateDateRange, strictDateValidation } from '../../../../utils/dateValidation';
const initialDateRange = getDatesForRangeType(THIS_MONTH, '', '');
const initialFilters = {
    values: {
        dateRange: {
            rangeType: THIS_MONTH,
            startDate: initialDateRange[0],
            endDate: initialDateRange[1]
        }
    },
    active: {
        dateRange: true
    }
};
export default function useFilters() {
    const [filters, setFilters] = useState(initialFilters);
    const onChangeDateFilter = useCallback((fieldName) => {
        return (dateFieldName, value) => {
            setFilters((prevFilters) => {
                const currentValues = prevFilters.values[fieldName];
                if (dateFieldName === 'rangeType') {
                    const newDates = getDatesForRangeType(value, '', '');
                    const validation = validateDateRange(newDates[0], newDates[1]);
                    if (validation.isValid) {
                        return Object.assign(Object.assign({}, prevFilters), { values: Object.assign(Object.assign({}, prevFilters.values), { [fieldName]: Object.assign(Object.assign({}, currentValues), { rangeType: value, startDate: newDates[0], endDate: newDates[1] }) }) });
                    }
                    return prevFilters;
                }
                const currentDateValues = currentValues;
                const strictValidation = strictDateValidation(value);
                if (!strictValidation.isValid) {
                    return prevFilters;
                }
                const startDate = dateFieldName === 'startDate' ? value : currentDateValues.startDate || '';
                const endDate = dateFieldName === 'endDate' ? value : currentDateValues.endDate || '';
                const validation = validateDateRange(startDate, endDate);
                if (validation.isValid) {
                    const newValues = Object.assign(Object.assign({}, currentValues), { rangeType: CUSTOM_RANGE, [dateFieldName]: value });
                    return Object.assign(Object.assign({}, prevFilters), { values: Object.assign(Object.assign({}, prevFilters.values), { [fieldName]: newValues }) });
                }
                return prevFilters;
            });
        };
    }, []);
    const onToggleFilter = useCallback((fieldName) => {
        return () => {
            setFilters((prevFilters) => (Object.assign(Object.assign({}, prevFilters), { active: Object.assign(Object.assign({}, prevFilters.active), { [fieldName]: !prevFilters.active[fieldName] }) })));
        };
    }, []);
    const onResetFilters = useCallback(() => {
        setFilters(initialFilters);
    }, []);
    const onResetCache = useCallback(() => {
        console.log('Cache reset requested');
    }, []);
    const filtersConfig = useMemo(() => [
        {
            field: 'dateRange',
            locale: 'date_range',
            type: 'dateRangePicker',
            active: filters.active.dateRange,
            locked: true,
            dateRanges: [THIS_MONTH, LAST_MONTH, THIS_QUARTER, LAST_QUARTER, THIS_YEAR, LAST_YEAR, CUSTOM_RANGE],
            values: {
                rangeType: filters.values.dateRange.rangeType,
                startDate: filters.values.dateRange.startDate,
                endDate: filters.values.dateRange.endDate
            },
            onChange: onChangeDateFilter('dateRange'),
            onToggle: onToggleFilter('dateRange')
        }
    ], [filters, onChangeDateFilter, onToggleFilter]);
    return {
        filters: filtersConfig,
        onResetFilters,
        onResetCache,
        currentFilters: filters
    };
}
